import { helper } from '@ember/component/helper';

export function trim([str]: [string]) {
  if (typeof str !== 'string') {
    throw new TypeError(`Expected a string, got a ${typeof str}`);
  }

  return str.trim();
}

export default helper(trim);
